module.exports = __webpack_public_path__ + "img/Weapon_135.714c179d.png";